export default {
  searchDate: 'GR Date/GI Date',
  byASN: 'By ASN',
  byDN: 'By DN',
  asn: 'ASN',
  asnQty: 'ASN Qty (Carton)',
  noScan: 'No Scan (Carton)',
  unitScanAccurate: 'Unit Scan Accurate (Carton)',
  qty: 'Qty',
  accuracyRate: 'Accuracy Rate',
  upcMissed: 'EPC Shortage (Carton)',
  upcExceeded: 'EPC Overage (Carton)',
  overallUpcMismatch: 'Overall UPC Mismatch (Carton)',
  noAsnUpcMismatch: 'No ASN UPC Mismatch (Carton)',
  dn: 'DN',
  giQty: 'GI Qty (Carton)',
  noDnUpcMismatch: 'No DN UPC Mismatch (Carton)',
  dataDefinition: 'Data Definition',
  definition1: `
    * EPC IB Scan Date passed ASN GR Date are excluded in above report calculation; 
    EPC OB Scan Date passed GI Date are excluded in above report calculation.`,
  definition2: `By ASN`,
  definition3: `
    ASN Qty (Carton): Aggregated ASN Carton quantity by ASN, in carton.
    <br/>
    No Scan (Carton):  Aggregated Carton quantity not scanned in tunnel while exisit in the ASN, in carton. 
    <br/>
		Unit Scan Accurate (Carton)
    <br/>
		- Qty: Aggregated Carton quantity which carton number exist in both scanned record and the ASN record, while UPC quantities are matched, in carton.  
    <br/>
		- Accuracy Rate: Unit Scan Accurate Qty (Carton) / ASN Qty (Carton)
    <br/>
		UPC Missed (Carton):  Aggregated Carton quantity which carton number exist in both scanned record and the ASN record, 
		while scanned UPC quantity is less than the ASN UPC quantity, in carton.
    <br/>
		UPC Excceeded (Carton): Aggregated Carton quantity which carton number exist in both scanned record and the ASN record, 
		while scanned UPC quantity is greater than the ASN UPC quantity, in carton.
    <br/>
    Overall UPC Mismatch (Carton): Aggregated Carton quantity which carton number exist in both scanned record and ASN record, 
    while scanned UPC does not belong to this Carton Number, or if the carton does not meet Scan missed/exceeded conditions, in carton. 
    <br/>
    No ASN UPC Mismatch (Carton): Aggregated Carton quantity which carton number exist in both scanned record and ASN record, 
    while scanned UPC does not belong to this Carton Number and does not belong to this ASN, in carton. 
`,
  definition4: `By DN`,
  definition5: `
		GI Qty (Carton): Aggregated GI Carton quantity by DN, in carton. 
		<br/>
		No Scan (Carton):  Aggregated Carton quantity not scanned in tunnel while exisit in the DN, in carton. 
		<br/>
		Unit Scan Accurate (Carton)
		<br/>
		- Qty: Aggregated Carton quantity which carton number exist in both scanned record and the GI record, while UPC quantities are matched, in carton.  
		<br/>
		- Accuracy Rate: Unit Scan Accurate Qty (Carton) / GI Qty (Carton)
		<br/>
		UPC Missed (Carton):  Aggregated Carton quantity which carton number exist in both scanned record and the GI DN record, 
		while scanned UPC quantity is less than the GI UPC quantity, in carton.
    <br/>
		UPC Excceeded (Carton): Aggregated Carton quantity which carton number exist in both scanned record and the GI DN record, 
		while scanned UPC quantity is greater than the ASN UPC quantity, in carton.
    <br/>
		Overall UPC Mismatch (Carton): Aggregated Carton quantity which carton number exist in both scanned record and GI DN record, 
		while scanned UPC does not belong to this Carton Number, or if the carton does not meet Scan missed/exceeded conditions, in carton. 
    <br/>
		No ASN UPC Mismatch (Carton): Aggregated Carton quantity which carton number exist in both scanned record and GI DN record, 
		while scanned UPC does not belong to this Carton Number and does not belong to this DN, in carton. 
    `
}
